import { motion, useTransform, MotionValue } from 'framer-motion';
import { AppConfig, ChaosPosition } from './types';
import { TIDY_POSITION, ANIMATION_CONFIG } from './constants';

interface AppCardProps {
  app: AppConfig;
  chaosPosition: ChaosPosition;
  scrollYProgress: MotionValue<number>;
  index: number;
}

export const AppCard: React.FC<AppCardProps> = ({
  app,
  chaosPosition,
  scrollYProgress,
  index
}) => {
  const [moveStart, moveEnd] = ANIMATION_CONFIG.chaosToTidyDuration;

  // Viewport-based positioning with centering offset
  // Using calc() to center: position - 50% of element size
  const x = useTransform(
    scrollYProgress,
    [moveStart, moveEnd],
    [`calc(${chaosPosition.x}vw - 50%)`, `calc(${TIDY_POSITION.x}vw - 50%)`]
  );

  const y = useTransform(
    scrollYProgress,
    [moveStart, moveEnd],
    [`calc(${chaosPosition.y}vh - 50%)`, `calc(${TIDY_POSITION.y}vh - 50%)`]
  );

  const rotation = useTransform(
    scrollYProgress,
    [moveStart, moveEnd],
    [chaosPosition.rotation, TIDY_POSITION.rotation]
  );

  const scale = useTransform(
    scrollYProgress,
    [moveStart, moveEnd],
    [chaosPosition.scale, TIDY_POSITION.scale]
  );

  const opacity = useTransform(
    scrollYProgress,
    ANIMATION_CONFIG.fadeOutCards,
    [1, 0]
  );

  const Icon = app.icon;

  return (
    <motion.div
      className="absolute left-1/2 top-1/2"
      style={{ x, y, rotate: rotation, scale, opacity }}
      initial={{ opacity: 1 }}
    >
      <div
        className="w-32 h-32 md:w-36 md:h-36 rounded-xl shadow-lg flex flex-col items-center justify-center gap-2 border-2"
        style={{
          backgroundColor: `${app.color}15`,
          borderColor: app.color,
        }}
      >
        <Icon className="w-8 h-8" style={{ color: app.color }} />
        <span className="text-sm font-medium text-foreground">{app.name}</span>
      </div>
    </motion.div>
  );
};
